import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { colors } from 'core/theme';

export const StyledCheckbox = styled.input`
    background-color: ${colors.background};
    border: 1px solid ${colors.lightText};
    border-radius: 2px;
    color: ${colors.background};
    width: 1rem;
    height: 1rem;
    -webkit-appearance: none;
    position: relative;
    vertical-align: top;

    margin: 0;
    margin-right: 0.5em;

    &:hover {
        border-color: ${colors.primaryLight};
    }

    &:checked {
        background-color: ${colors.primary};
        border-color: ${colors.primary};
        
        &:after {
            content: '✓';
            color: ${colors.background};
            display: inline-block;
            font-size: 1em;
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            pointer-events: none;
        }

        &:hover {
            background-color: ${colors.primaryLight};
            border-color: ${colors.primaryLight};
        }
    }

    ${({disabled}) => disabled && css`
        pointer-events: none;
    `};
`;



// WEBPACK FOOTER //
// ./src/elements/Checkbox/styled.js